import moment from 'moment-timezone'
import { leaveRequestService } from '../../../../services/others/leave-request-services'

export async function getLeaveRequestsByDate(startIso: string, endIso: string) {
  const startdate = moment.utc(startIso).format('YYYY-MM-DD')
  const enddate = moment.utc(endIso).format('YYYY-MM-DD')

  const response = await leaveRequestService.getByDate(startdate, enddate)
  return response.data.data ?? []
}
